import { EEVENT_LABEL } from 'affiny-core/analytics';
import { config } from 'affiny-core/env';
import { capitalize } from 'affiny-core/helpers/string/capitalize';
import { Container } from 'affiny-desktop/src/components/desktop/Container';
import { Box, Flex, rem } from 'affiny-ui/src';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FooterLink } from './FooterLink';

export const FOOTER_HEIGHT = rem(40);

export const Footer = () => {
  const { t } = useTranslation();

  const linksData = [
    {
      label: `footer.links.alerts`,
      url: '/settings/notifications',
      eventLabel: EEVENT_LABEL.FOOTER_WHOWEARE_CLICK,
    },
    {
      label: `footer.links.communityRules`,
      labelParam: { brand: capitalize(config.configStrategy.getBrand?.()) },
      url: '/settings/community',
      eventLabel: EEVENT_LABEL.FOOTER_CONDITIONS_CLICK,
    },
    {
      label: `footer.links.confidentialityConditions`,
      url: '/settings/confidentiality',
      eventLabel: EEVENT_LABEL.FOOTER_PRIVACY_CLICK,
    },
    {
      label: `footer.links.termsOfUse`,
      url: '/settings/use',
      eventLabel: EEVENT_LABEL.FOOTER_ENGAGEMENTS_CLICK,
    },
    {
      label: `footer.links.trustCharter`,
      url: '/settings/confiance',
      eventLabel: EEVENT_LABEL.FOOTER_HELP_CLICK,
    },
    {
      label: `footer.links.cookieSettings`,
      additionalCallback: 'window.MgCookiePolicy.openPreferenceCenter',
      eventLabel: EEVENT_LABEL.FOOTER_COOKIE_POLICY_CLICK,
    },
  ];

  return (
    <Box boxShadow="box" height={FOOTER_HEIGHT} bg="light">
      <Container height="100%" width="auto">
        <Flex
          height="100%"
          pb="small"
          alignItems="flex-end"
          justifyContent="space-evenly"
        >
          {linksData.map(({ label, labelParam, ...otherProps }, index) => (
            <FooterLink
              key={label}
              label={labelParam ? t(label, labelParam) : t(label)}
              isLastItem={index === linksData.length - 1}
              {...otherProps}
            />
          ))}
        </Flex>
      </Container>
    </Box>
  );
};
